"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitPaymentPlanOutput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DirectDebitPaymentSchedule_1 = require("./DirectDebitPaymentSchedule");
var DirectDebitFunctions_1 = require("./DirectDebitFunctions");
var commonFunctions_1 = require("../../../../commonFunctions");
var moment = require("moment/moment");
var journey_services_1 = require("@ferry/journey-services");
var portal_core_1 = require("@ferry/portal-core");
var DirectDebitPaymentPlanOutput = /** @class */ (function (_super) {
    __extends(DirectDebitPaymentPlanOutput, _super);
    function DirectDebitPaymentPlanOutput(props) {
        var _this = _super.call(this, props) || this;
        _this.renderContent = function () {
            var _a;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "mt-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "mb-3", children: (0, jsx_runtime_1.jsx)(DirectDebitPaymentSchedule_1.default, { isOpen: _this.state.isOpen, instalments: _this.props.interaction.paymentDetails.instalmentPlan.instalments || [], isPaidOff: false, interaction: _this.props.interaction }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: !((_a = _this.state) === null || _a === void 0 ? void 0 : _a.isOpen) ?
                            (0, jsx_runtime_1.jsxs)("button", { className: "direct-debit-btn-text text-center cursor-pointer", onClick: _this.toggleInstallmentPlan, children: ["+ ", (0, jsx_runtime_1.jsx)("span", { className: "btn-text", children: "View payment plan" })] })
                            :
                                (0, jsx_runtime_1.jsxs)("button", { className: "direct-debit-btn-text text-center cursor-pointer", onClick: _this.toggleInstallmentPlan, children: ["- ", (0, jsx_runtime_1.jsx)("span", { className: "btn-text", children: "Hide payment plan" })] }) })] }));
        };
        _this.toggleInstallmentPlan = function () {
            var _a;
            _this.setState({
                isOpen: !((_a = _this.state) === null || _a === void 0 ? void 0 : _a.isOpen)
            });
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    DirectDebitPaymentPlanOutput.prototype.render = function () {
        var interaction = this.props.interaction;
        var instalment = interaction.paymentDetails.instalmentPlan.instalments[0];
        var amount = instalment.principal + instalment.interest;
        var paymentDate = (0, DirectDebitFunctions_1.getFirstInstalmentDueDate)(interaction).format("Do MMMM YYYY");
        var paymentDateForMigratedRenewal = moment(instalment.dueDate).format("Do MMMM YYYY");
        var isMigratedRenewal = journey_services_1.MIGRATED_RENEWAL_STATUSES.includes(interaction.status);
        var numberOfInstalments = this.props.interaction.paymentDetails.instalmentPlan.instalments.length;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-left mt-4", children: [(0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Your first instalment will be on ", !isMigratedRenewal ? paymentDate : paymentDateForMigratedRenewal, " then on the same day of future months. You\u2019ll be able to change your payment day later in your account."] }) }), (0, jsx_runtime_1.jsxs)("p", { children: ["Below is a list of dates when we'll collect the payments (if your preferred payment date falls on a weekend or Bank Holiday, we'll take the payment on the next closest week day).\u00A0", this.getInstalmentsWording(numberOfInstalments, amount)] }), this.renderContent()] }));
    };
    DirectDebitPaymentPlanOutput.prototype.getInstalmentsWording = function (numberOfInstalments, amount) {
        var formattedAmount = (0, commonFunctions_1.getAmountWithDecimalDigits)(amount);
        return (0, commonFunctions_1.isSupportPortalMta)(this.props.interaction.process) ?
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You have ", numberOfInstalments, " instalments. Your next instalment will be ", formattedAmount, " and the remaining instalments can be found in your documents."] }) :
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You have ", numberOfInstalments, (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-bold", children: [" instalments of ", formattedAmount] })] });
    };
    return DirectDebitPaymentPlanOutput;
}(plugin_journey_1.WidgetBase));
exports.DirectDebitPaymentPlanOutput = DirectDebitPaymentPlanOutput;
//# sourceMappingURL=DirectDebitPaymentPlanOutput.js.map